export default __webpack_public_path__ + "static/media/dual-token.203f48b9.svg";